export const INTERNATIONAL_PAYMENT_FORM_KEYS = {
  ADDRESS_LINE_ONE: "address_line_one",
  ADDRESS_LINE_TWO: "address_line_two",
  CITY: "city",
  STATE: "state",
  PINCODE: "pincode",
};

export const INTERNATIONAL_PAYMENT_TEXTS = {
  MODAL_TITLE: "International Payment Creator Info",
  PRIMARY_BTN: "Submit",
  SECONDARY_BTN: "Cancel",
  REQUIRED_ERROR: "This field is required",
};

export const INTERNATIONAL_PAYMENT_FIELDS_CONFIG = {
  [INTERNATIONAL_PAYMENT_FORM_KEYS.ADDRESS_LINE_ONE]: {
    label: "Address Line 1",
    placeholder: "Enter address line 1",
    required: true,
  },
  [INTERNATIONAL_PAYMENT_FORM_KEYS.ADDRESS_LINE_TWO]: {
    label: "Address Line 2",
    placeholder: "Enter address line 2 (optional)",
    required: false,
  },
  [INTERNATIONAL_PAYMENT_FORM_KEYS.CITY]: {
    label: "City",
    placeholder: "Enter city",
    required: true,
  },
  [INTERNATIONAL_PAYMENT_FORM_KEYS.STATE]: {
    label: "State",
    placeholder: "Select state",
    required: true,
    isSelect: true,
  },
  [INTERNATIONAL_PAYMENT_FORM_KEYS.PINCODE]: {
    label: "Postal Code",
    placeholder: "Enter postal code",
    required: true,
  },
};

export const INTERNATIONAL_PAYMENT_FIELDS = Object.entries(
  INTERNATIONAL_PAYMENT_FIELDS_CONFIG
).map(([name, config]) => ({ name, ...config }));

export const DEBOUNCE_DELAY = 1000;

export const ADDRESS_KEYS = [
  INTERNATIONAL_PAYMENT_FORM_KEYS.ADDRESS_LINE_ONE,
  INTERNATIONAL_PAYMENT_FORM_KEYS.ADDRESS_LINE_TWO,
  INTERNATIONAL_PAYMENT_FORM_KEYS.CITY,
  INTERNATIONAL_PAYMENT_FORM_KEYS.STATE,
  INTERNATIONAL_PAYMENT_FORM_KEYS.PINCODE,
];
